// Vanilla-JS port of the source app's <Reveal> component (Framer Motion whileInView).
// Any element with [data-tap-reveal] fades/slides up once, the first time it enters the
// viewport. Honors prefers-reduced-motion by skipping the animation entirely.
(function () {
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var els = document.querySelectorAll('[data-tap-reveal]');
    if (!els.length) return;

    if (prefersReduced || !('IntersectionObserver' in window)) {
      els.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var delay = entry.target.getAttribute('data-tap-reveal-delay') || '0';
            entry.target.style.transitionDelay = delay + 's';
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0, rootMargin: '0px 0px -80px 0px' }
    );

    els.forEach(function (el) {
      observer.observe(el);
    });
  });
})();
